<template>
    <div >
        {{timeLeftLbl}}<span class="text-20">{{timeLeft}}</span>
    </div>
</template>
<script>
// helper
import TimerHelper from '@/helper/TimerHelper.js';
export default {
    name: 'CountDownTimer',
    props: {
        // v-model
        inputIsExpire: { type: Boolean },
        // props
        expireIn: { type: Number, required: true },
        // text
        timeLeftLbl: { type: String, required: true },
    },
    data: function () {
        return {
            timeLeft: '',
            timer: new TimerHelper()
        };
    },
    mounted: function () {
        this.initTimer();
    },
    methods: {
        initTimer: function () {
            this.timer.initialTimer(this.expireIn, ':', false, false);
            this.$emit('update:inputIsExpire', false);
            this.timer.runTimer(
                (timeLeft) => {
                    this.timeLeft = timeLeft;
                }, () => {
                    this.$emit('update:inputIsExpire', true);
                });
        }
    }
}
</script>
